import React from 'react'
import { useQuery } from 'react-apollo-hooks'
import DeleteAccount from './components/DeleteAccount'
import CreateCase from './components/CreateCase'
import { urls } from '../resources'
import { LinkWithIcon, SettingBox, Loader } from '../application'
import DownloadCase from './components/DownloadCase'
import OngoingCase from './components/OngoingCase'
import getText from './strings'
import { Divider, Container } from '../styles'
import * as Queries from './queries'

export default () => {
  const { loading, data } = useQuery(Queries.getCase())

  return (
    <Container>
      <h2>{getText('overview', 'settings')}</h2>
      <LinkWithIcon to={urls.profile} icon="chevron-left" text={getText('overview', 'back')} />
      <SettingBox header={getText('overview', 'privacySettings')}>
        <DeleteAccount />
        <Divider />
        <CreateCase
          caseType="forgetme"
          header={getText('overview', 'deleteInformation')}
          description={getText('overview', 'deleteInformationInformation')}
          actionLabel={getText('overview', 'deleteInformationCTA')}
          wizardHeading={getText('overview', 'deleteInformationOverlayHeadline')} />
        <Divider />
        {loading && <Loader />}
        {!loading && !data.extractCase &&
          <CreateCase
            caseType="extract"
            header={getText('overview', 'requestInformation')}
            description={getText('overview', 'requestInformationInformation')}
            actionLabel={getText('overview', 'requestInformationCTA')}
            wizardHeading={getText('overview', 'requestDataOverlayHeadline')}
          />
        }
        {data && data.extractCase &&
          (data.extractCase.ready
            ? <DownloadCase caseId={data.extractCase.id} />
            : <OngoingCase  {...data.extractCase} />
          )
        }
      </SettingBox>
    </Container>
  )
}
